/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useState } from 'react'
import { Table, Divider, Row, Col, Button, Modal, Select, DatePicker } from 'antd'
import styles from './index.less'
import moment from 'moment'
import { RESERVE_STATUS_ENUM, TASK_STATUS_MAP } from '@/utils/consts'

const { Option } = Select

const ReserveInfo = ({ data, reserveStatus, source, pagination, onChange, assistantDoctor, consultantDoctor, personalDoctor, onEdit, onEditStatus, onAddReserveFollow }) => {
  const [reserveStatusVisible, setReserveStatusVisible] = useState(false)
  const [selectRocord, setSelectRecord] = useState({})
  const [arrivedAt, setArrivedAt] = useState(null)

  const columns = [
    {
      dataIndex: 'reservationAt',
      title: '预约日期',
      width: 140,
      render(text) {
        return moment(text).format('YYYY-MM-DD')
      }
    },
    {
      dataIndex: 'startAt',
      title: '预约时间',
      width: 180,
      render(text, record) {
        return text && <span>{text ? moment(text).format('HH:mm') : ''}-{record.endAt ? moment(record.endAt).format('HH:mm') : ''}</span>
      }
    },

    {
      dataIndex: 'clinicShortName',
      title: '预约门店',
      width: 160,
    },
    {
      dataIndex: 'status',
      title: '预约状态',
      width: 140,
      render(text) {
        if (text && reserveStatus && reserveStatus.some(_ => _.value === text))
          return <span className={text}>{reserveStatus.filter(_ => _.value === text)[0].key}</span>
        return text
      },
    },

    // {
    //   dataIndex: 'consultantName',
    //   title: '心理顾问',
    //   width: 80,
    //   render(text) {
    //     return consultantDoctor
    //   }
    // },
    // {
    //   dataIndex: 'housekeeperName',
    //   title: '全程管家',
    //   width: 80,
    //   render(text) {
    //     return personalDoctor
    //   }
    // },
    // {
    //   dataIndex: 'discount',
    //   title: '在线医助',
    //   width: 80,
    //   render(text) {
    //     return assistantDoctor
    //   }
    // },
    {
      dataIndex: 'operation',
      title: '操作',
      width: 140,
      align: 'center',
      render(text, record) {
        return source !== 'task' && <Fragment>
          <a href="javascript:void(0);" disabled={record.status === 'executed' || record.status === 'cancel' || (record.status === 'arrival' && !record.backTracking)} onClick={() => onEdit('update', record)}>编辑</a>
          <Divider type="vertical" />
          <a href="javascript:void(0);" disabled={record.status === 'executed' || record.status === 'cancel' || record.status === 'arrival'} onClick={() => handleEditStatus(record)}>更改状态</a>
        </Fragment>
      }
    }
  ]

  const handleEdit = record => {

  }

  const handleEditStatus = record => {
    setSelectRecord({ ...record })
    setReserveStatusVisible(true)
  }

  const reserveStatusProps = {
    width: 300,
    visible: reserveStatusVisible,
    title: '更改预约状态',
    size: 'small',
    item: selectRocord,
    closable: false,
    style: { textAlign: 'center' },
    onOk() {
      let payload = {
        id: selectRocord.id,
        status: selectRocord.status
      }
      let payloadFollow = {
        followUpId: selectRocord.id,
        followUpType: 'Reservation',
      }
      if (selectRocord.status === reserveStatus.filter(_ => _.key === '到店')[0].value) {
        if (!arrivedAt) return
        payload.arrivedAt = arrivedAt
      }
      onEditStatus(payload, selectRocord.customerId);
      setReserveStatusVisible(false)
      if (selectRocord.status === reserveStatus.filter(_ => _.key === '取消')[0].value) {
        onAddReserveFollow(payloadFollow)
      }
      setSelectRecord({})
    },
    onCancel() {
      setSelectRecord({})
      setReserveStatusVisible(false)
    }
  }

  return (
    <div className={styles.reserve}>
      <Table
        columns={columns}
        dataSource={data}
        pagination={{
          ...pagination,
          onChange
        }}
        defaultExpandAllRows={true}
        expandedRowRender={expandedRowRender}
        expandIcon={({ expanded, onExpand, record }) => record.reservationItemResps ? <span className='icon-wrapper'><span className={expanded ? 'icon-expanded' : 'icon-collapse'} onClick={onExpand} /></span> : null}
        size="small"
        rowKey="id"
      />
      {reserveStatusVisible && <Modal {...reserveStatusProps}>
        <Select style={{ width: 200 }} defaultValue={selectRocord.status} onChange={e =>
          setSelectRecord({ ...selectRocord, status: e })
        }>
          {reserveStatus && reserveStatus.map(_ => {
            if (_.key === '已执行') {
              return
            } else if (_.key === '取消') {
              if (selectRocord.cancelAble) {
                return <Option value={_.value} key={_.value}>{_.key}</Option>
              } else {
                return
              }
            } else if (_.key === '待确认') {
              if (selectRocord.cancelAble) {
                return <Option value={_.value} key={_.value}>{_.key}</Option>
              } else {
                return
              }
            } else {
              return <Option value={_.value} key={_.value}>{_.key}</Option>
            }
          })}
        </Select>
        {reserveStatus.filter(_ => _.value === selectRocord.status) &&
          (reserveStatus.filter(_ => _.value === selectRocord.status)[0].key === '到店' || reserveStatus.filter(_ => _.value === selectRocord.status)[0].key === '已执行') &&
          <DatePicker
            style={{ width: 200, marginTop: 20 }}
            placeholder='请选择到店时间'
            onChange={e => setArrivedAt(e)}
          />}
      </Modal>}
    </div>
  )
}

export default ReserveInfo

function expandedRowRender(record) {
  const columns = [
    {
      title: '序号',
      key: '$id.js.less',
      render: (_, record, index) => index + 1,
      width: 60,
      align: 'center',
    },
    {
      title: '商品类别',
      key: 'productCategoryName',
      render: (_, record) => (record.categoryList || []).map(_ => _.name).join('/')
    },
    {
      title: '商品名称',
      dataIndex: 'productName',
    },
    {
      title: '执行人',
      dataIndex: 'employeeName',
      width: 120,
    },
    {
      title: '预约时间',
      dataIndex: 'startAt',
      width: 120,
      render(text, record) {
        return text && <span>{text ? moment(text).format('HH:mm') : ''}-{record.endAt ? moment(record.endAt).format('HH:mm') : ''}</span>
      }
    },
    {
      title: '执行状态',
      width: 120,
      align: 'center',
      dataIndex: 'status',
      render: (status) => <span className={status}>{TASK_STATUS_MAP[status]}</span>
    },
    {
      title: '总服务次数',
      dataIndex: 'totalServiceCount',
      width: 110
    },
    // {
    //   title: '本次消耗次数',
    //   dataIndex: 'totalCount',
    //   width: 110
    // },
    {
      title: '本次消耗金额',
      dataIndex: 'consumptionPrice',
      width: 110,
      render: (amount) => amount >= 0 ? amount && amount.toFixed(2) + '元' : undefined
    },
  ]

  if (record.reservationItemResps) {
    return (
      <Fragment>
        <h4 className='order-items-label'>预约明细</h4>
        <Table columns={columns} pagination={false} bordered={false} dataSource={record.reservationItemResps || []} size='small' />
      </Fragment>)
  } else {
    return false
  }
};
